export default __webpack_public_path__ + "static/media/banner3.bc40ed6d.png";